import { Component, Input, OnInit } from '@angular/core';
import { CoreBuildingBlockControlBaseComponent } from '../../shared/building-block-control-base.component';
import { FieldInstance } from '@workflow/class/field.service';

@Component({
  selector: 'cu-checkbox-group',
  templateUrl: './checkbox-group.component.html'
})
export class CheckboxGroupComponent extends CoreBuildingBlockControlBaseComponent implements OnInit {
  /** current card */
  @Input() public fields: FieldInstance[];

  ngOnInit(): void {}
}
